"use client";

import { Heading } from "@/app/components/client";

interface GlobalErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

/**
 * Global error page
 */
export default function GlobalError(props: GlobalErrorProps): JSX.Element {
	return (
		<html lang="en">
			<body>
				<div className="text-center p-md">
					<Heading
						textContent="500 | Global error"
						className="mb-lg"
					/>
					<button onClick={props.reset}>Retry</button>
				</div>
			</body>
		</html>
	);
}
